(() => {
  'use strict';
  const storefrontUrl = value => {
    if (!value) return '';
    try { return new URL(value, document.baseURI || window.location.href).href; }
    catch (_) { return value; }
  };
  const controllers = new WeakMap();
  function init(root) {
    if (controllers.has(root)) return;
    const controller = new AbortController(); controllers.set(root, controller);
    root.querySelectorAll('.header-utilities').forEach(el => el.classList.add('is-enhanced'));
    root.addEventListener('change', e => {
      if (e.target.matches('[data-locale-select]')) e.target.form.requestSubmit();
    }, { signal: controller.signal });
    root.addEventListener('click', e => {
      const scene = e.target.closest('[data-card-scene-toggle]');
      if (scene) {
        const link = scene.closest('[data-color-card]').querySelector('.m05-image-toggle');
        const available = matchMedia('(max-width:700px)').matches ? link?.dataset.alternateMobile : link?.dataset.alternateDesktop;
        if (!link || available === 'false') return;
        scene.setAttribute('aria-pressed', String(link.classList.toggle('is-alternate')));
        return;
      }
      const choice = e.target.closest('[data-card-color]');
      if (!choice) return;
      const card = choice.closest('[data-color-card]'); if (!card) return;
      card.querySelectorAll('[data-card-color]').forEach(el => el.setAttribute('aria-pressed', String(el === choice)));
      card.querySelectorAll('.m05-image-primary,.finder-primary,.j21-rec-image img').forEach(img => {
        if (!choice.dataset.cardImage) return;
        const picture = img.closest('picture'), mobileSource = picture?.querySelector('source');
        // Update the selected product image on both devices, preserving explicit overrides.
        if (!card.dataset.mediaDesktop || card.dataset.mediaDesktop === 'product') {
          img.removeAttribute('srcset'); img.src = choice.dataset.cardImage;
        }
        if (!card.dataset.mediaMobile || card.dataset.mediaMobile === 'product') {
          if (mobileSource) mobileSource.srcset = choice.dataset.cardImage;
          else if (picture && card.dataset.mediaDesktop && card.dataset.mediaDesktop !== 'product') {
            const source = document.createElement('source'); source.media = '(max-width:700px)'; source.srcset = choice.dataset.cardImage; picture.prepend(source);
          }
        }
      });
      card.querySelectorAll('[data-card-price]').forEach(el => { el.textContent = choice.dataset.price; });
      card.querySelectorAll('[data-card-compare]').forEach(el => { el.textContent = choice.dataset.comparePrice; el.hidden = !choice.dataset.comparePrice; });
      card.querySelectorAll('.m05-image-toggle').forEach(el => el.classList.remove('is-alternate'));
      card.querySelectorAll('[data-card-scene-toggle]').forEach(el => el.setAttribute('aria-pressed','false'));
      const originalPrice=Number(choice.dataset.compareRaw||0),salePrice=Number(choice.dataset.priceRaw||0);
      const percent=originalPrice>salePrice?Math.round((originalPrice-salePrice)*100/originalPrice):0;
      card.querySelectorAll('[data-card-discount]').forEach(el=>{el.hidden=percent<=0;el.textContent='-'+percent+'%';el.setAttribute('aria-label','Sconto '+percent+'%');});
      const variantUrl = storefrontUrl(choice.dataset.variantUrl);
      if (variantUrl) {
        card.querySelectorAll('.m05-image-toggle,.m05-product-name a,.finder-media,.finder-card-meta h2 a,.finder-quick,.j21-rec-image,.j21-rec-card h3 a').forEach(el => { el.href = variantUrl; });
        card.querySelectorAll('[data-quick-buy-url]').forEach(el => { el.dataset.quickBuyUrl = variantUrl; });
      }
    }, { signal: controller.signal });
  }
  // One delegated listener survives section rendering, filters and quick-shop replacement.
  init(document);
  let headerFrame = 0;
  function syncHeaderContrast() {
    headerFrame = 0;
    const header = document.querySelector('.site-header.logo-menu');
    const hero = document.querySelector('.hero.m01-carousel');
    if (header) header.classList.toggle('is-past-hero', !hero || hero.getBoundingClientRect().bottom <= 84);
  }
  function queueHeaderContrast() {
    if (!headerFrame) headerFrame = requestAnimationFrame(syncHeaderContrast);
  }
  window.addEventListener('scroll', queueHeaderContrast, { passive: true });
  window.addEventListener('resize', queueHeaderContrast);
  queueHeaderContrast();
  document.addEventListener('shopify:section:load', e => { e.target.querySelectorAll('.header-utilities').forEach(el => el.classList.add('is-enhanced')); });
  document.addEventListener('shopify:section:load', queueHeaderContrast);
})();
